<template>
  <v-container fluid class="pa-0">
    <v-card outlined class="rounded-lg pa-4">
      <div class="d-flex align-center mb-4">
        <v-avatar size="48" class="section-icon mr-3" rounded>
          <v-icon color="white">mdi-file-document-edit-outline</v-icon>
        </v-avatar>
        <div>
          <div class="text-subtitle-1 font-weight-bold primary--text">Page Editor</div>
          <div class="text-caption grey--text">Edit and publish content for your website's pages</div>
        </div>
      </div>

      <v-select
        v-model="selectedPage"
        :items="pages"
        item-text="title"
        item-value="id"
        label="Select Page to Edit"
        outlined
        prepend-inner-icon="mdi-file-outline"
        @change="loadPage"
      />

      <div class="editor-wrap mb-4">
        <quill-editor
          v-model="content"
          :options="editorOptions"
        />
      </div>

      <v-btn color="primary" rounded elevation="2" class="font-weight-bold text-none" @click="savePage" :loading="saving">
        <v-icon left>mdi-cloud-upload-outline</v-icon>
        Save &amp; Publish
      </v-btn>
    </v-card>
  </v-container>
</template>

<script>
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.snow.css';
import axios from 'axios';

export default {
  components: { quillEditor },
  props: ['websiteId'],
  data() {
    return {
      pages: [],
      selectedPage: null,
      content: '',
      saving: false,
      editorOptions: {
        placeholder: 'Start writing your content here...',
      }
    };
  },
  methods: {
    async fetchPages() {
      const res = await axios.get(`/api/websites/${this.websiteId}/pages`);
      this.pages = res.data;
    },
    async loadPage() {
      const res = await axios.get(`/api/pages/${this.selectedPage}`);
      this.content = res.data.content;
    },
    async savePage() {
      this.saving = true;
      try {
        await axios.put(`/api/pages/${this.selectedPage}`, {
          content: this.content,
          published: true
        });
        this.$toast.success('Page saved successfully!');
      } catch (e) {
        this.$toast.error('Save failed.');
      } finally {
        this.saving = false;
      }
    }
  },
  mounted() {
    this.fetchPages();
  }
};
</script>

<style scoped>
.section-icon {
    background: linear-gradient(135deg, #1E3C72 0%, #2A5298 100%);
}
.editor-wrap >>> .ql-toolbar {
    border-radius: 8px 8px 0 0;
    background: #F4F6FB;
    border-color: #ECEFF7;
}
.editor-wrap >>> .ql-container {
    border-radius: 0 0 8px 8px;
    border-color: #ECEFF7;
    min-height: 200px;
}
</style>
